<template>
  <div class="detail">
    <el-dialog
      title="处理详情内容"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose">

      <h3 v-if="picList.length" style="margin-bottom: 10px;">处理沟通证明</h3>
      <el-image class="img" v-for="item in picList" :key="item" :src="item" :preview-src-list="picList" />
      <h3 v-if="row && row.processExplain" style="margin-bottom: 10px;">备注</h3>
      <p>{{ row ? row.processExplain : '' }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="" size="small" @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'detail',
  data () {
    return {
      dialogVisible: false,
      row: null,
      picList: []
    }
  },
  methods: {
    init(row) {
      this.row = row
      this.picList = row.processImg ? row.processImg.split(',') : []
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.row = null
      this.picList = []
    }
  }
}
</script>

<style lang="scss" scoped>
.detail {
  ::v-deep .img {
    width: 100px;
    height: 100px;
    img {
      object-fit: cover;
    }
  }
}
</style>
